/* eslint-disable react/no-unused-prop-types */
import classNames from 'classnames';
import { isNumber } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import MLButton from '../MLButton';
import MLIcon from '../MLIcon/MLIcon';
import s from './CategoryNameButton.module.css';

const formatDropLowestString = (dropLowestNumGrades) => {
  if (!dropLowestNumGrades) return null;
  const gradeStr = dropLowestNumGrades > 1 ? 'grades' : 'grade';
  const displayNumber =
    dropLowestNumGrades === 1 ? '' : dropLowestNumGrades + ' ';
  return `drops ${displayNumber}lowest ${gradeStr}`;
};

const CategoryNameButton = ({
  category,
  handleCategoryTabToggle,
  active,
  isDisabled,
  activeIcon = 'plus',
  inactiveIcon = 'minus',
  categoryNameClassName,
  weightsClassName,
  collapseButtonClassName,
  showWeightLabel = false,
  testId,
}) => {
  const {
    gradebook_category_name: gradebookCategoryName,
    name,
    weight = 0,
    drop_lowest_num_grades,
  } = category;

  const displayName = gradebookCategoryName || name;
  const dropLowestString =
    isNumber(drop_lowest_num_grades) &&
    formatDropLowestString(drop_lowest_num_grades);

  return (
    <MLButton
      ariaExpanded={!active}
      className={classNames(s.categoryNameCollapseBtn, collapseButtonClassName)}
      onClick={() => handleCategoryTabToggle(category.gradebook_category_id)}
      disabled={isDisabled}
      testId={testId}
    >
      <MLIcon
        className={classNames(s.categoryNameCollapseIcon, {
          [s.disabledIcon]: isDisabled,
        })}
        type={active ? activeIcon : inactiveIcon}
      />
      <span className={classNames(s.name, categoryNameClassName)}>
        <span className={s.label}>{displayName}</span>
        {showWeightLabel && (
          <span
            className={classNames(s.weights, weightsClassName)}
          >{`${Number(weight)}% of Total`}</span>
        )}
        {dropLowestString && (
          <i className={s.dropLowest}>({dropLowestString})</i>
        )}
      </span>
    </MLButton>
  );
};

CategoryNameButton.propTypes = {
  category: PropTypes.object,
  containerClassName: PropTypes.string,
  categoryNameClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  activeIcon: PropTypes.string,
  inactiveIcon: PropTypes.string,
  handleCategoryTabToggle: PropTypes.func,
  active: PropTypes.bool,
  isDisabled: PropTypes.bool,
  showWeightLabel: PropTypes.bool,
};

export default CategoryNameButton;
